/* angular:styles/component:css;20379a7cd021c27312d1f996971509065d319be5facc0d233189a5ec9f1a3575;/home/runner/work/evrideonewuiux/evrideonewuiux/app-client-code/app/js/src/components/pop-over/pop-over.component.ts */
.pop-over-content {
  position: absolute;
  transition: opacity 0.2s ease-in-out;
  background: #ffffff;
  z-index: 1060;
}
/*# sourceMappingURL=pop-over.component.css.map */
